import axios from 'axios';
import api from '@/services/api'
import { withCountryCode, selectedCountryCode } from '@/services/currency'
import router from "@/router"
const state = {
    userCart: [],
    cartItems: [],
    currency:"",
    currencySymbol:"",
    paymentType:"",

    courseCart:[],
    assetCart:[],

    itemsSummary:[],
    buyBtnLoading: false,

    discountCode:"",
    amountDiscount:0,
    cartTotalDiscount:0,
}
const mutations = {
    UPDATE_CART_ITEMS (state, payload) {
        // The API returns `[]` (not {user_cart, cart_items, currency}) once the
        // cart is empty/deleted - default to empty values instead of undefined
        // so the UI reliably renders "empty" and nothing downstream (e.g.
        // userCart.cart_id) throws trying to read off of undefined.
        state.userCart  = payload.user_cart || {};
        state.cartItems = payload.cart_items || [];
        state.currency  = payload.currency || "";
        state.currencySymbol = payload.currency_symbol || "";

        state.cartBtnLoading = false;
        state.buyBtnLoading = false;
        // Discount
        if(Array.isArray(state.cartItems) && state.cartItems.length > 0){
            state.cartTotalDiscount = state.cartItems.reduce((acc, cartItem) => {
                let item_price = cartItem.price;
                if(cartItem.is_offer){
                    item_price = cartItem.offer_price;
                }
                return (cartItem.quantity * item_price ) + acc;
            }, 0).toFixed(2) - state.amountDiscount;
        }else{
            state.cartTotalDiscount = 0;
        }
    },
    CLEAR_CART (state) {
        state.userCart = {};
        state.cartItems = [];
        state.cartTotalDiscount = 0;
        state.amountDiscount = 0;
        state.discountCode = "";
    },
    UPDATE_DISCOUNT (state, payload) {
        state.discountCode      = payload.code;
        state.amountDiscount    = payload.amount;
    },
    UPDATE_BUY_BTN_STATUS (state, status) {
        state.buyBtnLoading = status;
    },
    UPDATE_PAYMENT_TYPE (state, payload) {
        state.paymentType  = payload;
    },
}
const actions = {
    getCartItems ({ commit }, userID) {
        axios.get(withCountryCode(api.getUrl('/cart/'+userID))).then((response) => {
            if(response.data.success){
                commit('UPDATE_CART_ITEMS', response.data.data)
            }
        }).catch(() => {
            // error  
        });
    },
    getCouponDiscount ({ commit }, discount) {
        commit('UPDATE_DISCOUNT', discount);
    },
    addCartItem ({ commit }, cartItem) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                axios.post(api.getUrl('/cart/store'), { ...cartItem, country_code: selectedCountryCode() }).then((response) => {
                    if(response.data.success){
                        commit('UPDATE_CART_ITEMS', response.data.data)
                        resolve(response.data.data); // Resolve with fetched data
                    }else{
                        reject(response.data.data); // Reject on failure
                    }
                }).catch(() => {
                    // error
                });
            }, 1000);
        });
    },
    buyCartItem ({ commit }, cartItem) {
        commit('UPDATE_BUY_BTN_STATUS', true)
        axios.post(api.getUrl('/cart/store'), { ...cartItem, country_code: selectedCountryCode() }).then((response) => {
            if(response.data.success){
                commit('UPDATE_CART_ITEMS', response.data.data)
                router.push({ name: "CartCheckout" })
            }else{
                commit('UPDATE_BUY_BTN_STATUS', false)
            }
        }).catch(() => {
            commit('UPDATE_BUY_BTN_STATUS', false)
        });
    },
    removeCartItem ({ commit }, cartItem) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                axios.post(api.getUrl('/cart/delete'),{ id:cartItem.id, item_id:cartItem.item_id,item_type:cartItem.type, country_code: selectedCountryCode() }).then(function (response) {
                    if(response.data.success){
                        commit('UPDATE_CART_ITEMS', response.data.data)
                        if(response.data.data.length === 0){
                            if(router.history.current.name ==='CartCheckout'){
                                router.push({ name: "Home" }).catch(()=>{});
                            }else{
                                router.push({ name: router.history.current.name }).catch(()=>{});
                            }
                        }
                        resolve(response.data.data); // Resolve with fetched data
                    }else{
                        reject(response.data.data); // Reject on failure
                    }
                }).catch(() => {
                    // error  
                });
            }, 1000);
        });
    },
    setPaymentType({ commit }, option){
        commit('UPDATE_PAYMENT_TYPE', option)
    },
    // Called right when a payment/free-checkout succeeds, so the cart reads as
    // empty immediately instead of waiting on a getCartItems round-trip.
    clearCart({ commit }){
        commit('CLEAR_CART');
    },
}
const getters = {
    cartBtnLoading: state => state.cartBtnLoading,
    buyBtnLoading: state => state.buyBtnLoading,
    userCart: state => state.userCart,
    cartItems: state => state.cartItems,
    currency: state => state.currency,
    currencySymbol: state => state.currencySymbol,
    cartTotal: state => {
        if(Array.isArray(state.cartItems)){
            return state.cartItems.reduce((acc, cartItem) => {
                let item_price = cartItem.price;
                if(cartItem.is_offer){
                    item_price = cartItem.offer_price;
                }
                return (cartItem.quantity * item_price ) + acc;
            }, 0).toFixed(2);
        }return 0;
    },

    discountCode:state => state.discountCode,
    cartTotalDiscount: state => state.cartTotalDiscount,
    amountDiscount: state => state.amountDiscount,

    cartQuantity: state => {
        if(Array.isArray(state.cartItems)){
            return state.cartItems.reduce((acc, cartItem) => {
                return cartItem.quantity + acc;
            }, 0);
        }return 0;
    },
    cartItemSummary: state => {
        state.itemsSummary = [];
        if(Array.isArray(state.cartItems)){
            state.cartItems.forEach((value) => {
                let item = {};
                item.item_id        =  value.item_id;
                item.item_type      =  value.item_type;
                item.price          =  value.price;
                item.offer_price    =  value.offer_price;
                item.qty            =  value.quantity;
                state.itemsSummary.push(item);
            });
        }
        return state.itemsSummary;
    },
    courseCartItems: state => {
        state.courseCart = [];
        if(Array.isArray(state.cartItems)){
            state.cartItems.forEach((value) => {
                if(value.item_type ==='course'){
                    state.courseCart.push(value.item_id);
                }
            });
        }
        return state.courseCart;
    },
    assetCartItems: state => {
        state.assetCart = [];
        if(Array.isArray(state.cartItems)){
            state.cartItems.forEach((value) => {
                if(value.item_type ==='asset'){
                    state.assetCart.push(value.item_id);
                }
            });
        }
        return state.assetCart;
    },
}
export default {
    state,
    mutations,
    actions,
    getters
}